import { render, staticRenderFns } from "./EntityAdd.vue?vue&type=template&id=4a20b976"
import script from "./EntityAdd.vue?vue&type=script&lang=js"
export * from "./EntityAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports